(() => {
  'use strict';
  if (document.documentElement.dataset.delifreshFacetsReady) return;
  document.documentElement.dataset.delifreshFacetsReady = 'true';
  let active = null,
    trigger = null;
  const close = () => {
    if (!active) return;
    active.classList.remove('is-open');
    active.removeAttribute('role');
    active.removeAttribute('aria-modal');
    active.nextElementSibling?.setAttribute('hidden', '');
    document.body.classList.remove('filters-open');
    if (trigger?.isConnected) trigger.focus();
    active = null;
  };
  document.addEventListener('click', (event) => {
    const sortOption = event.target.closest('[data-sort-value]');
    if (sortOption) {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sortOption.dataset.sortValue);
      url.searchParams.delete('page');
      location.assign(url.href);
      return;
    }
    const open = event.target.closest('[data-open-filters]');
    if (open) {
      active = document.getElementById(open.dataset.openFilters);
      if (!active) return;
      trigger = open;
      active.classList.add('is-open');
      active.setAttribute('role', 'dialog');
      active.setAttribute('aria-modal', 'true');
      active.setAttribute('aria-label', open.textContent.trim());
      active.nextElementSibling?.removeAttribute('hidden');
      document.body.classList.add('filters-open');
      active.querySelector('button')?.focus();
    }
    if (event.target.closest('[data-close-filters]')) close();
    document.querySelectorAll('[data-sort-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    const openSort = document.querySelector('[data-sort-dropdown][open]');
    if (event.key === 'Escape' && openSort) {
      event.preventDefault();
      openSort.open = false;
      openSort.querySelector('summary')?.focus();
      return;
    }
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
    if (event.key === 'Tab') {
      const elements = [
        ...active.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select,summary'),
      ].filter((el) => el.getClientRects().length);
      const first = elements[0],
        last = elements.at(-1);
      if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-sort]')) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  document.addEventListener('shopify:section:unload', close);
})();
